<mat-card appearance="outlined" id="container">
  <div id="data">
    <div id="meta-tags">
      <app-document-select [selectControl]="documentTypeSelect" [documentTypes]="documentTypes"></app-document-select>

      <mat-form-field appearance="fill">
        <mat-label>Dokumentum dátuma</mat-label>
        <input matInput [matDatepicker]="picker" [formControl]="documentDate" />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
        <mat-error>Kötelező mező használd a naptár ikont.</mat-error>
        <mat-hint>Használd a kis naptár ikont</mat-hint>
      </mat-form-field>
    </div>
    <!-- only of new document -->
    @if (newEventId) {
      <div id="file-tags">
        <input accept=".doc,.docx,.pdf,.jpg,.jpeg,.png" type="file" (change)="fileSelected($event.target.files)" />
        @if (selectedFile) {
          <p id="file-details">Név: {{ selectedFile?.name }} méret: {{ selectedFileSize }}</p>
        }
      </div>
    }

    <!-- download url for existing document -->
    @if (document) {
      <div id="download-container">
        <!-- <p>Feltöltve: {{ document.createdAt | date: 'medium' }} - Feltöltötte: {{ document.createdBy }}</p> -->
        <p>Feltöltötte: {{ document.createdBy }}</p>
        <a [href]="document.downloadUrl" target="_blank">Letöltés</a>
      </div>
    }

    @if (percentChange) {
      <mat-progress-bar id="progress-bar" [value]="percentChange | async"></mat-progress-bar>
    }

    @if (errorMessage) {
      <mat-error>{{ errorMessage }}</mat-error>
    }
    <mat-card-actions>
      @if (!document) {
        <button
          [disabled]="!areFieldsValid() || percentChange"
          mat-raised-button
          color="primary"
          type="button"
          (click)="startUpload()"
          >
          Feltöltés
        </button>
      }
      @if (canRenew) {
        <button mat-button color="accent" type="button" (click)="renewDocument()">Megújítás</button>
        <button mat-button color="accent" type="button" (click)="sendEmailForDocument()">Email küldése</button>
      }
      <button mat-button color="warn" type="button" (click)="deleteDocument()">Törlés</button>
    </mat-card-actions>
  </div>
  @if (sanitizedDocumentUrl && showPreview) {
    <div id="preview">
      @if (document.fileType.includes('pdf')) {
        <object
          height="250"
          width="550"
          [data]="sanitizedDocumentUrl"
          [type]="document.fileType"
        ></object>
      }
      @if (document.fileType.includes('jpg') || document.fileType.includes('jpeg') || document.fileType.includes('png')) {
        <img
          [src]="sanitizedDocumentUrl"
          height="250"
          width="auto"
          />
      }
    </div>
  }
</mat-card>
